'use client'

import { getItemAccessoryId } from './cart-utils'
import { useAnchorLinkScroll, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { AddNote } from '@dustin-web/product-components/src/add-note-to-cart-item'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { useReactiveVar } from '@dustin-web/microsite-components/src/hooks/use-reactive-var'
import { productErpIdentifiersWithAccessoriesVar } from './cart-accessories'
import type { GenericAvailabilityType } from '@dustin-web/product-components/src/cards'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'
import ProductOutOfStock from './cart-item-out-of-stock'

type Availability = GenericAvailabilityType & { isAvailableForSale: boolean }

type Props = {
  availability: Availability | null | undefined
  comment: string | null
  cartItem: CartItemFragment
  disableEditing?: boolean
  mainProductErpIdentifier: string | null | undefined
  productErpIdentifier: string
}
export const CartItemUtilityRow = ({
  availability,
  comment,
  cartItem,
  disableEditing = false,
  productErpIdentifier,
  mainProductErpIdentifier,
}: Props) => {
  const isAvailableForSale = availability?.isAvailableForSale || cartItem.isMandatory

  const showAddComment = !cartItem.mainProductErpIdentifier

  return (
    <div className='c-shoppingcart__utility-row d-print-none'>
      <div className='c-shoppingcart__utility-row--direction'>
        {isAvailableForSale ? (
          <>
            {showAddComment && !disableEditing && (
              <AddNote
                comment={comment}
                cartItemId={cartItem.id}
                inFavorites={false}
                disableEditing={disableEditing}
              />
            )}
            <ChooseAccessories
              mainProductErpIdentifier={mainProductErpIdentifier}
              productErpIdentifier={productErpIdentifier}
              cartItem={cartItem}
            />
          </>
        ) : (
          <ProductOutOfStock
            productErpIdentifier={cartItem.productErpIdentifier}
            productNameSlug={cartItem.product?.nameSlug}
          />
        )}
      </div>
    </div>
  )
}

type ChooseAccessoriesProps = {
  mainProductErpIdentifier: string | null | undefined
  productErpIdentifier: string
  cartItem: CartItemFragment
}

const ChooseAccessories = ({
  mainProductErpIdentifier,
  productErpIdentifier,
  cartItem,
}: ChooseAccessoriesProps) => {
  const { translate } = useTranslations()
  const productErpIdentifiersWithAccessories = useReactiveVar(
    productErpIdentifiersWithAccessoriesVar
  )
  const { buttonOnClick } = useAnchorLinkScroll()
  const itemId = getItemAccessoryId(cartItem)

  const hasAccessories =
    !mainProductErpIdentifier && productErpIdentifiersWithAccessories.has(productErpIdentifier)

  if (!hasAccessories) return null

  return (
    <button
      className={'button-stripped u-mb-8 u-mr-12 u-fs-12 u-decoration-none'}
      onClick={() => buttonOnClick(itemId)}>
      <Icon name="arrow-down" className="u-mr-4 i-16" />
      <span className="d-none d-md-inline">{translate('Choose_Accessories')}</span>
      <span className="d-md-none">{translate('Choose_Accessories_Short')}</span>
    </button>
  )
}

export default CartItemUtilityRow
